import { DotLottieReact } from "@lottiefiles/dotlottie-react";
import { memo } from "react";

interface LoadingScreenProps {
  isOnboardingRoute: boolean;
}

export const LoadingScreen = memo(({ isOnboardingRoute }: LoadingScreenProps) => {
  return (
    <div className="flex h-screen flex-col items-center justify-center">
      {isOnboardingRoute ? (
        <div className="h-16 w-16 animate-spin rounded-full border-4 border-blue-500 border-t-transparent" />
      ) : (
        <DotLottieReact
          src="https://lottie.host/0a9e63ee-47c1-4c18-8ade-3fbc3c34ff2b/KHFMpj2e09.lottie"
          loop
          autoplay
          speed={2.5}
          className="h-32 w-32 rounded-full border-4 border-[#bde6e6]"
        />
      )}
      {!isOnboardingRoute && (
        <div className="mt-4 text-2xl font-bold text-gray-500">Préparation de votre expérience...</div>
      )}
    </div>
  );
});

LoadingScreen.displayName = "LoadingScreen";
